import { Options } from 'vue-class-component';
import AssignRoomObjectGeneralStep from '../AssignRoomObjectGeneralStep';
import {
  DeviceDTO,
  DevicesFilterByType,
  SlotStatus,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import AddDeviceToLinkableObject from '@/views/components/AddDeviceToLinkableObject/AddDeviceToLinkableObject.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';

@Options({
  name: 'Step2',
  components: {
    AddDeviceToLinkableObject,
  },
  watch: {
    atLeastOneDeviceAndSlotSelected: function () {
      this.validateNextEnabled();
    },
  },
})
export default class Step2 extends AssignRoomObjectGeneralStep {
  devicesActuators: DeviceDTO[] = [];

  get currentDevicesActuators() {
    return this.roomObject.devices?.filter((x) => x.isActuatorDevice);
  }

  created() {
    this.validateNextEnabled();
  }

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      this.devicesActuators = await plantsClient.devices(
        this.plantId,
        this.roomId,
        this.roomObject.id ?? '',
        DevicesFilterByType.ACTUATORS,
        this.roomObject.lightType || undefined,
        undefined,
        undefined,
        undefined
      );
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  get atLeastOneDeviceAndSlotSelected() {
    return (
      this.currentDevicesActuators?.some((k) =>
        k.slots?.some(
          (s) =>
            s.status == SlotStatus.MarkedForLinking ||
            (s.status == SlotStatus.Configured &&
              s.linkedObjects?.some((l) => l.id === this.roomObject.id))
        )
      ) ?? false
    );
  }

  validateNextEnabled() {
    this.nextEnabled = this.atLeastOneDeviceAndSlotSelected;
  }
}
